/**
 * Ryan O'Dowd
 * 2024-05-13
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({globalScale, colors, isDarkMode}) => {
  return {
    menuContainer: {
      flex: 1,
    },
    container: {
      minWidth: 300, // @TODO: don't love hardcoding, but edit-assignment dialog numLessons + lesson difficulty looks weird without it
      justifyContent: 'center',
      padding: globalScale * 8,
    },
    placeholderAndArrowWrapper: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    text: {
      color: isDarkMode ? colors.white : colors.primaryExtraDark,
    },
    placeholderText: {
      color: isDarkMode ? colors.gray : colors.lightGray,
    },
    icon: {
      color: isDarkMode ? colors.gray : colors.lightGray,
      fontSize: globalScale * 24,
    },
    menuWrapper: (width) => {
      return {
        width,
      };
    },
    menuWrapperContent: {
      width: '100%',
    },
    menuItem: {
      minWidth: '100%',
      width: '100%',
    },
    menuItemContent: {
      minWidth: '100%',
      width: '100%',
    },
  };
};

export default getStyles;
